"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureBuyReducer = featureBuyReducer;
var _types = require("./types");
var _types2 = require("../config/types");
var _types3 = require("../game/types");
var initialState = {
  currentFeatureTrigger: undefined,
  showDialog: false,
  showButton: true,
  enabled: false,
  availableFeatures: [],
  isFeatureBuy: false
};
function featureBuyReducer() {
  var _action$payload;
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _types2.SERVER_CONFIG:
      /// Server config is sent mulitple times
      // in our case we need to first check if its the queryparam where launcher sets
      // second case we check if its the server config passed from game server.
      // if ftb=true in qp AND we get featureBuys from server config then we should activate it.
      if (action.payload.ftb !== undefined) {
        return Object.assign({}, state, {
          configEnabled: action.payload.ftb
        });
      } else if ((_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.featureBuy) {
        var _action$payload2, _action$payload3;
        return Object.assign({}, state, {
          availableFeatures: action.payload.featureBuy,
          currentFeatureTrigger: ((_action$payload2 = action.payload) === null || _action$payload2 === void 0 || (_action$payload2 = _action$payload2.featureBuy) === null || _action$payload2 === void 0 ? void 0 : _action$payload2.length) > 0 ? action.payload.featureBuy[0] : undefined,
          enabled: ((_action$payload3 = action.payload) === null || _action$payload3 === void 0 || (_action$payload3 = _action$payload3.featureBuy) === null || _action$payload3 === void 0 ? void 0 : _action$payload3.length) > 0 && state.configEnabled ? true : false
        });
      }
    case _types.SET_CURRENT_FEATURE_BUY_BY_FEATURE_SET:
      {
        var ft = state.currentFeatureTrigger;
        for (var index = 0; index < state.availableFeatures.length; index++) {
          if (action.payload == state.availableFeatures[index].featureSet) ft = state.availableFeatures[index];
        }
        return Object.assign({}, state, {
          currentFeatureTrigger: ft
        });
      }
    case _types.CLOSE_FEATURE_BUY:
      return Object.assign({}, state, {
        showDialog: false
      });
    case _types.OPEN_FEATURE_BUY:
      return Object.assign({}, state, {
        showDialog: true
      });
    case _types.TOGGLE_FEATURE_BUY:
      return Object.assign({}, state, {
        showDialog: !state.showDialog,
        showButton: state.showDialog
      });
    case _types.SHOW_FEATURE_BUY_BUTTON:
      return Object.assign({}, state, {
        showButton: true
      });
    case _types.HIDE_FEATURE_BUY_BUTTON:
      return Object.assign({}, state, {
        showButton: false
      });
    case _types.FEATURE_BOUGHT:
      return Object.assign({}, state, {
        isFeatureBuy: true
      });
    case _types3.ROUND_END:
      return Object.assign({}, state, {
        isFeatureBuy: false
      });
  }
  return state;
}
//# sourceMappingURL=reducer.js.map